var generateStyle = function generateStyle() {
  return {
    metricLabelContainer: {
      maxWidth: '159px'
    },
    metricLabel: {
      margin: '0',
      textTransform: 'capitalize',
      paddingRight: '24px'
    },
    popoverContainer: {
      paddingLeft: '5px',
      marginLeft: '-24px' /* same as metricLabel padding. This makes sure that the icon never wraps below the text */
    }
  };
};
export default generateStyle;